import { render, staticRenderFns } from "./gateway-crm-account-confirmation-demo.vue?vue&type=template&id=3dc75908&"
import script from "./gateway-crm-account-confirmation-demo.vue?vue&type=script&lang=js&"
export * from "./gateway-crm-account-confirmation-demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports